<template>
    <tr
        v-if="!isBeingEdited"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ role.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            {{ role.from }}
        </td>
        <td class="kgr-table__cell">
            {{ role.to }}
        </td>
        <td class="kgr-table__cell">
            {{ departmentName }}
        </td>
        <td class="kgr-table__cell">
            {{ teamName }}
        </td>
        <td class="kgr-table__cell notice">
            <p v-for="noticeLine in notice">
                {{ noticeLine }}
            </p>
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <kgr-icon-edit
                v-if="role.isEditable"
                :size="15"
                class="kgr-table__action"
                @click="$emit('edit')"
            />
            <kgr-icon-delete
                v-if="role.isDeletable"
                class="kgr-table__action"
                @click="$emit('remove')"
            />
        </td>
    </tr>
</template>

<script>
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import MemberRole from '../../../js/dto/MemberRole';

export default {
    components: {
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
    },
    props: {
        role: {
            type: MemberRole,
            required: true
        },
        editRoles: {
            type: Array,
            required: true
        },
    },
    computed: {
        isBeingEdited() {
            return this.editRoles.map(editRole => editRole.id).indexOf(this.role.id) !== -1;
        },
        notice() {
            return null === this.role.notice ? []: this.role.notice.split('\n');
        },
        departmentName() {
            return this.role.department ? this.role.department.extendedName() : '';
        },
        teamName() {
            return this.role.team ? this.role.team.extendedName() : '';
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .notice {
        white-space: pre-line;
    }

    .kgr-table__cell {
        vertical-align: top;
    }
</style>
